<template>
  <section class="PricingCol" :chargeHelp="chargeHelp">
    <div class="PricingParent">
      <div class="Cities DayTime" v-if="shouldShowOldStyle">
        <button
          v-for="city in cities"
          :key="city"
          @click="() => click(city)"
          :data-selected="currentCity === city"
          class="City"
        >
          {{ city }}
          <div class="UnderLine"></div>
        </button>
      </div>

      <div class="dropdown" ref="dropdown" v-else-if="shouldShowNewStyle">
        <button
          id="country-dropdown"
          class="flex justify-between items-center"
          ref="countryDropdown"
          aria-haspopup="true"
          aria-expanded="false"
          @mouseenter="openDropdown"
          @focus="openDropdown"
          @mouseleave="scheduleClose"
          @blur="scheduleClose"
        >
          <span id="selected-country">{{ currentCity }}</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="63"
            height="4"
            viewBox="0 0 63 4"
            fill="none"
            style="    position: absolute;    bottom: 12px;"
          >
            <path
              d="M2.68433 2L60.7539 2"
              stroke="#FFDF22"
              stroke-width="4"
              stroke-linecap="round"
            />
          </svg>

          <svg
            width="28"
            height="22"
            viewBox="0 0 384 512"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M192 384c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L192 306.8l137.4-137.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-160 160C208.4 380.9 200.2 384 192 384z"
            />
          </svg>
        </button>

        <ul
          role="menu"
          aria-labelledby="country-dropdown mt-1"
          class="dropdown-content"
          v-show="isDropdownOpen"
          @mouseenter="cancelCloseSchedule"
          @mouseleave="scheduleClose"
          @focusin="cancelCloseSchedule"
          @focusout="scheduleClose"
        >
          <li
            v-for="city of cities"
            :key="city"
            :value="city"
            class="menu-item"
            role="menuitem px-1"
          >
            <button
              @click="selectCountry(city)"
              @keydown.enter="selectCountry(city)"
              class="w-full text-left py-3 px-3"
            >
              {{ city }}
            </button>
          </li>
        </ul>
      </div>
      <div v-if="currentTariff.night.maxSignificand" class="Flex">
        <div class="PricingRect Day">
          <img src="~@/assets/pricing_day.svg" />
          <div class="DayTitle">{{ $t('pricing.card1_header') }}</div>
          <div class="DayTime">
            {{ currentTariff.day.time.replace('to', $t('pricing.time')) }}
          </div>
          <div class="PriceGrid">
            <img class="ChargeSvg" src="~@/assets/price_charge.svg" />
            <img class="TimeSvg" src="~@/assets/price_time.svg" />
            <div class="kW">
              {{ currentTariff.day.infraCost + '/kWh' }}
            </div>
            <div class="min">
              {{ currentTariff.day.value + '/min' }}
            </div>
          </div>
        </div>
        <div class="PricingRect Night">
          <img src="~@/assets/pricing_night.svg" />
          <div class="NightTitle">{{ $t('pricing.card2_header') }}</div>
          <div class="NightTime">
            {{ currentTariff.night.time.replace('to', $t('pricing.time')) }}
          </div>
          <div class="PriceGrid">
            <img class="ChargeSvg" src="~@/assets/price_charge.svg" />
            <img class="TimeSvg" src="~@/assets/price_time.svg" />
            <div class="kW">
              {{ currentTariff.night.infraCost + '/kWh' }}
            </div>
            <div class="min">
              {{ currentTariff.day.value + '/min' }}
            </div>
            <div class="max">
              {{
                $t('pricing.card2_priceinfo').replace(
                  '$max_cost',
                  currentTariff.night.max
                )
              }}
            </div>
          </div>
        </div>
      </div>
      <div v-else class="mt-5 p-4 md:p-8 rounded-lg Night">
        <div class="flex items-center justify-between my-6">
          <div class="flex items-center space-x-2">
            <img class="ChargeSvg w-5 h-5" src="~@/assets/price_charge.svg" />
            <div class="">
              <p class="w-32 md:w-40 text-white text-md md:text-xl">
                {{ $t('pricing.power') }}
              </p>
            </div>
          </div>
          <div class="text-md text-white md:text-xl">
            {{ currentTariff.day.infraCost + '/kWh' }}
          </div>
        </div>
        <div class="flex items-center justify-between my-6">
          <div class="flex items-center space-x-2">
            <img class="TimeSvg w-5 h-5" src="~@/assets/price_time.svg" />
            <div class="">
              <p class="w-32 md:w-40 text-white text-md md:text-xl">
                {{ $t('pricing.infrastructureFee') }}
              </p>
            </div>
          </div>
          <div class="text-md text-white md:text-xl">
            {{ currentTariff.day.value + '/min' }}
          </div>
        </div>
      </div>
      <div class="Details">
        <div
          v-for="(paragraph, idx) in $t('pricing.detail')
            .replace('$max_cost', this.currentTariff.night.max)
            .split('\n')
            .filter(Boolean)"
          :key="idx"
          :id="idx"
        >
          <div
            v-if="
              (!currentTariff.night.maxSignificand && idx === 1) ||
                currentTariff.night.maxSignificand
            "
          >
            {{ paragraph }}
          </div>
        </div>
      </div>
    </div>
    <div class="SpaceBottom" />
  </section>
</template>

<script>
import tariffs from '@/data/tariffs.json';
import { entity } from '../../../region.json';
import matchEntities from '../../shared/entityHelpers';

export default {
  name: 'Tariffs',
  props: {
    chargeHelp: {
      type: Boolean,
      default: false,
    },
    updateCurrentCity: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      entity,
      tariffs: tariffs[entity],
      currentCity: tariffs[entity].cities[0],
      isDropdownOpen: false,
    };
  },
  computed: {
    currentTariff() {
      const tariff = this.tariffs.data.find(({ city }) => {
        return city === this.currentCity;
      })?.tariff;
      return tariff;
    },
    shouldShowOldStyle() {
      return this.cities.length > 1 && this.cities.length < 4;
    },
    shouldShowNewStyle() {
      return this.cities.length > 3;
    },
    cities() {
      return (
        this.tariffs.cities?.slice().sort((a, b) => a.localeCompare(b)) ?? []
      );
    },
  },
  methods: {
    click(city) {
      this.currentCity = city;
      this.updateCurrentCity(city);
    },
    matchEntities,
    selectCountry(value) {
      this.updateCurrentCity(value);
      this.currentCity = value;
      // Your existing selection logic
      this.closeDropdown();
    },
    keepDropdownOpen() {
      clearTimeout(this.closeTimer);
    },

    openDropdown() {
      this.isDropdownOpen = true;
      this.$refs.countryDropdown.setAttribute('aria-expanded', 'true');
    },

    scheduleClose() {
      this.closeTimer = setTimeout(() => {
        this.closeDropdown();
      }, 100); // Small delay to allow for interaction
    },

    cancelCloseSchedule() {
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
    },

    closeDropdown() {
      this.isDropdownOpen = false;
      this.$refs.countryDropdown.setAttribute('aria-expanded', 'false');
    },
  },
};
</script>

<style scoped>
#country-dropdown {
  padding: 1rem 1rem;
  border: unset;
  outline: unset;
  width: 100%;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.25);
}

#selected-country {
}

.dropdown {
  position: relative;
  display: inline-block;
  grid-column: 3;
  grid-row: 1;
  width: 100%;
}

.menu-item:hover {
  background-color: #ffdf22;
}

.dropdown-content {
  display: none;
  width: 100%;
  border-radius: 12px;
  height: 230px;
  overflow-y: scroll;
  position: absolute;
  background-color: #f9f9f9;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.dropdown-content img {
  width: 100px;
  height: 100px;
  padding: 8px;
  cursor: pointer;
}
.dropdown-content img:hover {
  background-color: #ddd;
}
.dropdown:hover .dropdown-content,
.dropdown:focus-within .dropdown-content {
  display: block;
}
.dropdown-content:hover {
  display: block;
}

.dropdown-content.visible {
  display: block;
}

/* Ensure focus is visible */
button:focus,
.dropdown-content button:focus {
  outline: 2px solid #4a90e2;
  outline-offset: 2px;
}
/* Essam style end */
select {
  padding: 5px 10px;
  border: 1px solid #cccccc;
  border-radius: 4px;
  font-family: 'Arial', sans-serif;
}
.PricingParent {
  display: block;
  width: 85%;
}

.buttonParent {
  display: flex;
  justify-content: center;
  align-items: center;
}
/* apply margin only to first button */
.buttonParent > div:nth-of-type(1) {
  margin-right: 2em;
}
.buttonParent > button {
  font-weight: normal;
}
.City {
  font-size: var(--city-btn-f-size);
  color: #2b4047;
}
.City {
  outline: none;
}
.UnderLine {
  height: 5px;
  width: 100%;
  border-bottom: 2px solid #c8d1d3;
  border-radius: 15px;
}

.City[data-selected='true'] > .UnderLine {
  border-bottom: 5px solid #ffdf22;
}
.City[data-selected='true'] {
  font-weight: bold;
}

.InnerParent {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.PricingCol {
  --day-bg: #ffffff;
  --day-color: #2b4047;
  --day-time-text-color: #5e7177;
  --day-title-color: #2b4047;
  --night-bg: #2b4047;
  --night-color: #ffffff;
  --night-time-text-color: #a1b1b5;
  --night-title-color: #ffffff;
  --price-title-f-size: 24px;
  --price-title-margin: 12px;
  --rect-h: 266px;
  --rect-w: 200px;
  --day-margin-right: 0;
  --day-margin-bottom: 1.5em;
  --space-top: 92px;
  --space-bottom: 70px;
  --text-color: #41565d;
  --max-f-size: 14px;
  --time-f-size: 14px;
  --time-margin: 3px;
  --metrics-f-size: 20px;
  --details-f-size: 12px;
  --subtitle-margin: 32px;
  --subtitle-f-size: 16px;
  --title-margin: 32px;
  --title-f-size: 30px;
  --text-margin: 64px;
  --text-f-size: 14px;
  --price-grid-margin: 26px;
  --grid-gap: 4px;
  --charge-svg-size: 100%;
  --metrics-svg-size: 100%;
  --flex-m-top: 34px;
  --underline-width: 80px;
  --city-btn-f-size: 14px;
}
.TextCol,
.PricingCol {
  margin: 0 auto;
  flex-direction: column;
}
.PricingCol {
  max-width: 100%;
}
.SpaceTop {
  height: var(--space-top);
}
.SpaceBottom {
  height: var(--space-bottom);
}

.Subtitle {
  font-size: var(--subtitle-f-size);
  color: var(--day-time-text-color);
  letter-spacing: 2.4px;
  margin-bottom: var(--subtitle-margin);
}
.Title {
  line-height: normal;
  font-size: var(--title-f-size);
  font-family: Foco;
  color: var(--night-bg);
  font-weight: bold;
  margin-bottom: var(--title-margin);
}
.Text {
  font-size: var(--text-f-size);
  color: var(--text-color);
  margin-bottom: var(--text-margin);
}
.PricingRect {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: var(--rect-h);
  padding: 1em;
  width: var(--rect-w);
  box-shadow: 0px 7px 20px #0033;
  border-radius: 8px;
}
.Flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: var(--flex-m-top);
  flex-direction: column;
}
.PricingCol[chargeHelp='true'] {
  max-width: 100%;
}
.PricingCol[chargeHelp='true'] .Flex {
  display: flex;
  column-gap: 1em;
  flex-direction: row;
  align-items: unset;
}

.PricingCol[chargeHelp='true'] .Day,
.PricingCol[chargeHelp='true'] .Night {
  width: 100%;
}
.Day {
  background: var(--day-bg);
  margin-right: var(--day-margin-right);
  margin-bottom: var(--day-margin-bottom);
}
.Day > img {
  max-width: 38px;
}
.Night {
  background: var(--night-bg);
}
.Night > img {
  max-width: 39px;
}
.DayTitle,
.NightTitle {
  font-weight: bold;
  font-size: var(--price-title-f-size);
  font-family: Foco;
  line-height: normal;
  margin-top: var(--price-title-margin);
}
.DayTitle {
  color: var(--day-title-color);
}
.NightTitle {
  color: var(--night-title-color);
}
.DayTime,
.NightTime {
  font-size: var(--time-f-size);
  margin-top: var(--time-margin);
}
.DayTime {
  color: #5e7177;
}
.NightTime {
  color: #a1b1b5;
}
.PriceGrid {
  display: grid;
  grid-template-areas: 'charge kw' 'time min' '. max';
  align-items: center;
  grid-gap: var(--grid-gap);
  margin-top: var(--price-grid-margin);
  grid-template-columns: 14px auto;
}
.ChargeSvg {
  grid-area: charge;
  width: var(--metrics-svg-size);
}
.TimeSvg {
  grid-area: time;
  width: var(--metrics-svg-size);
}
.TimeSvg[data-sweden='true'] {
  margin-top: 8px;
  align-self: flex-start;
}
.kW {
  grid-area: kw;
}
.min {
  grid-area: min;
}
.summerCampaign {
  color: #a1b1b5 !important;
  text-decoration: line-through;
}
.green {
  color: #7dcc93 !important;
}
.kW,
.min {
  font-size: var(--metrics-f-size);
}
.Day .kW,
.Day .min {
  color: #2b4047;
}
.Night .kW,
.Night .min {
  color: #ffffff;
}
.max {
  grid-area: max;
  font-size: var(--max-f-size);
  color: #a1b1b5;
  margin-top: -0.3em;
}
.Details {
  color: #a1b1b5;
  letter-spacing: 0.16px;
  font-size: var(--details-f-size);
  max-width: calc((var(--rect-w) * 2) + var(--day-margin-right));
  margin: 1.6em auto 0 auto;
  width: 85%;
}
.Details div:first-child {
  margin-bottom: 1em;
}

@media (max-width: 700px) {
  .PricingParent {
    width: 100%;
  }
}

@media (min-width: 400px) {
  .PricingCol {
    max-width: 85%;
  }
}
@media (min-width: 500px) {
  .PricingCol {
    --rect-w: 172px;
    --rect-h: 244px;
    --price-title-f-size: 19px;
    --time-f-size: 11px;
    --metrics-f-size: 13px;
    --max-f-size: 12px;
    --space-bottom: 120px;
    --day-margin-right: 1em;
    --day-margin-bottom: 0;
  }
  .PriceGrid {
    grid-template-columns: 18px auto;
  }
  .TextCol {
    max-width: 85%;
    margin: 0;
  }
  .Flex {
    justify-content: center;
    flex-direction: row;
    align-items: stretch;
  }
}
@media (min-width: 880px) {
  .PricingCol {
    display: grid;
    grid-template-columns: 1fr 1fr;
    --min-height: 100%;
    --space-bottom: 0px;
    margin-bottom: 5em;
    margin-top: 6em;
    --underline-width: 104px;
    --city-btn-f-size: 20px;
  }
  .PricingCol {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    max-width: 100%;
    margin: 0;
  }
  .TextCol {
    max-width: 100%;
    margin: 0;
  }
  .Flex {
    justify-content: flex-end;
  }

  .Details {
    align-self: flex-end;
    margin: 1.6em 0 0 0;
  }
}
@media (min-width: 1026px) {
  .PricingCol {
    --subtitle-f-size: 20px;
    --title-f-size: 30px;
    --text-f-size: 16px;
    --space-bottom: 0px;
    --details-f-size: 12px;
  }
  .Title,
  .Text {
    max-width: 95%;
  }
}
@media (min-width: 1271px) {
  .PricingCol {
    --title-f-size: 50px;
    --text-f-size: 17px;
    --rect-h: 285px;
    --rect-w: 201px;
    --price-title-f-size: 22px;
    --time-f-size: 13px;
    --metrics-f-size: 16px;
  }
  .PricingRect {
    padding-top: 30px;
  }
  .Day > img {
    max-width: 100%;
    width: 58px;
  }
  .Night > img {
    max-width: 100%;
    width: 58px;
  }
  .PriceGrid {
    grid-template-columns: 18px auto;
  }
  .Title {
    line-height: 1.3;
  }
  .Title,
  .Text {
    max-width: 90%;
  }
}

@media (min-width: 1350px) {
  .PricingCol {
    --rect-h: 342px;
    --rect-w: 241px;
    --price-title-f-size: 26px;
    --time-f-size: 16px;
    --metrics-f-size: 19px;
    --price-title-margin: 22px;
    --max-f-size: 18px;
    --details-f-size: 16px;
  }
  .PriceGrid {
    grid-template-columns: 22px auto;
  }
  .Title {
    line-height: 1.2;
  }
  .max {
    margin-top: -0.5em;
  }
}

@media (min-width: 1750px) {
  .PricingCol {
    --title-f-size: 70px;
    --text-f-size: 20px;
    --subtitle-margin: 40px;
    --title-margin: 60px;
    --rect-h: 446px;
    --rect-w: 314px;
    --price-title-f-size: 30px;
    --price-title-margin: 35px;
    --time-f-size: 20px;
    --time-margin: 4px;
    --metrics-f-size: 28px;
    --max-f-size: 24px;
    --price-grid-margin: 45px;
    --grid-gap: 8px;
    --day-margin-right: 2.8em;
    --flex-m-top: 92px;
    margin-top: 4em;
    margin-bottom: 6em;
  }
  .PricingCol {
    justify-content: center;
  }
  .PriceGrid {
    grid-template-columns: 32px auto;
  }
  .Title {
    line-height: 1.3;
    max-width: 90%;
  }
  .Text {
    max-width: 90%;
  }
  .PricingRect {
    padding-top: 40px;
  }
  .Day > img {
    max-width: 100%;
    width: 76px;
  }
  .Night > img {
    max-width: 100%;
    width: 78px;
  }
}
.Cities {
  display: flex;
  width: 100%;
  justify-content: space-evenly;
}
</style>
